import { useEffect, useState } from "react";
import axios from "axios";

const usePastEventDashboard = (teamId, confirmId, enabled) => {
  const [dashboard, setDashboard] = useState(null);

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    axios.get(`/teams/${teamId}/e/${confirmId}/dashboard`)
      .then(({ data }) => { if (!cancelled) setDashboard(data.dashboard); });
    return () => { cancelled = true; };
  }, [teamId, confirmId, enabled]);

  return dashboard;
};

export default usePastEventDashboard;
